var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"30","height":"30","viewBox":"0 0 24 24","fill":_vm.fill,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16.2426 6.34317L14.8284 4.92896L7.75739 12L14.8285 19.0711L16.2427 17.6569L10.5858 12L16.2426 6.34317Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }